module.exports = __webpack_public_path__ + "static/media/hint_screenshot.e71bf351.png";